import React from 'react';
import ReactDOMServer from 'react-dom/server';

export interface IMapboxCustomButton {
  title: string;
  icon: string;
}
export const mapboxCustomButton = ({ title, icon }: IMapboxCustomButton) => {
  const jsx: JSX.Element = (
    <button type="button">
      <span
        title={title}
        className={`map-controls-button-icon ${icon} `}
      ></span>
    </button>
  );

  return ReactDOMServer.renderToString(jsx);
};
